import React, { useEffect, useState } from 'react';
import { Button, Result, Spin, Typography } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSubscriptionMe } from '../../../libs/ohat-api';

const POLL_INTERVAL = 2000;
const TIMEOUT_MS = 30000;

/**
 * 決済完了ページ。Webhook 反映は success_url への戻りより遅れるため、
 * GET /subscriptions/me を2秒間隔でポーリングし、planKey が light になったら完了表示する。
 */
export const PlanCompletePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [timedOut, setTimedOut] = useState(false);

  const { data: planInfo } = useSubscriptionMe({
    query: {
      retry: false,
      refetchInterval: (query) => {
        const reflected =
          (query.state.data as { planKey?: string } | undefined)?.planKey === 'light';
        // 反映済み、またはタイムアウト後はポーリングを止める
        return reflected || timedOut ? false : POLL_INTERVAL;
      },
    },
  });

  const isReflected = planInfo?.planKey === 'light';

  useEffect(() => {
    if (!sessionId) {
      navigate('/plan');
    }
  }, [sessionId, navigate]);

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, []);

  if (isReflected) {
    return (
      <Result
        status="success"
        title={t('plan.completeTitle')}
        subTitle={t('plan.completeDesc')}
        extra={[
          <Button type="primary" key="home" onClick={() => navigate('/')}>
            {t('plan.backToHome')}
          </Button>,
        ]}
      />
    );
  }

  if (timedOut) {
    return (
      <Result
        status="info"
        title={t('plan.processingTitle')}
        subTitle={t('plan.processingDesc')}
        extra={[
          <Button type="primary" key="plan" onClick={() => navigate('/plan')}>
            {t('plan.backToPlan')}
          </Button>,
          <Button
            key="contact"
            href="https://medi-banx.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.contact')}
          </Button>,
        ]}
      />
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 16,
      }}
    >
      <Spin size="large" />
      <Typography.Text type="secondary">{t('plan.processingTitle')}…</Typography.Text>
    </div>
  );
};
